module.exports = "/_next/static/images/migration-53062b95e1eadc641c3a2edf6ae2d9c2.webp";